import { getPersistenceData, setPersistenceData, removePersistenceData } from "./persistenceStorage";

const SiteCookieKey = "Site";

export function getDomainSite() {
    return getPersistenceData(SiteCookieKey, null);
}

export function setDomainSite(site) {
    return setPersistenceData(SiteCookieKey, site);
}

export function removeDomainSite() {
    return removePersistenceData(SiteCookieKey);
}
